"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = _interopRequireDefault(require("../Input"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    display: inline-block;\n    width: ", ";\n    & input {\n        font-family: Password !important;\n        -webkit-font-smoothing: antialiased;\n        -moz-osx-font-smoothing: grayscale;\n    }\n    @font-face {\n        font-family: 'Password';\n        src: url(data:application/x-font-woff;charset=utf-8;base64,d09GRgABAAAAAAO4AAoAAAAAB8wAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABPUy8yAAAA9AAAAD4AAABWVqRjK2NtYXAAAAE0AAAARgAAAUoKhxCZZ2x5ZgAAAXwAAAA9AAACCO8m6+poZWFkAAABvAAAAC0AAAA2E0g3HmhoZWEAAAHsAAAAGwAAACQHKgQMaG10eAAAAggAAAAPAAAALCwAAABsb2NhAAACGAAAABgAAAAYAooDDG1heHAAAAIwAAAAHwAAACABFgAYbmFtZQAAAlAAAAE7AAACbdWMZSRwb3N0AAADjAAAACkAAABEBTUFI3icY2BkYWCcwMDKwMHUyXSGgYGhH0IzvmYwYuRgYGBiYGVmwAoC0lxTGBwYDBgsWUDcGBaIMCOIAACVwgeDAAB4nGNgYGBmgGAZBkYGEHAB8hjBfBYGDSDNBqQZGZiALMv//8EqDED0/4tQ9UDAyMZAMmBkYmZhZWPn4OQiXe9gBADVEgc1AAB4nGNgZAACprNMLxm4GRgY5RjN7RjN9RjZ+RgZTdgO5BiYMbLvzzUwY2KoyjOXibUAkwyjeoadHgAwsGCbAAAAeJxjYGRgYADi3T65VfH8Nl8ZuFkYQODGuso5yDTTWaaXQIqDgQnEAwAvKAqZAAAAeJxjYGRgYGEAghgwycB0loGRARVwAwAaXgFBAHicY2FgYGAhEgMABEwALQAAAAAAABoANABOAGgAggCcALYA0ADqAQR4nGNgZGBg4GbgYQDRDAxMQMwFhAwM/8F8BgAKtgEvAHicdY9LTsMwEIZ/9wW0EqqoYIfkBWIBKH2IVTfsmn0X3aet04fSOHLcSj0A5+EInIAj0BtwB37SAaFSYnn8zTeTcQLgAjso7J9L7j0rnDLbcwknuBYu098IV8gPwlU08Chco38SruMeoXADLThOUJUzZnd4FlZo4kW4hHO8Cpfp34Qr5HfhKq7wIVxDU5WF6xiplnADt2oRmtS4yJupHm91mGyzuTfu+xya2TqJ3KEeGZcvbKq7Qeen9HtMvpn1vI917OxKD2zqTZJYnTm7NBMfzL3P+u12LD6Y2BV/3yDldojgeU6hMcaWMUTCM8O88O5PPmScYU0bHake5qMi5ljA8j6NLgJ0jrz139fk2PC2Hq1HzDxmj8WKNCgmfnUnXJYmK2pLmgl9UEz3tH20ueKD/oBdnPQJNGNvpAB4nGNgYoAALgbsgJuBgZGJkZmRhZGVkY2RnZGDkZORi5EbWQkACnAAYwAAAA==);\n        font-weight: normal;\n        font-style: normal;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/* eslint one-var: off */
var Root = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.inputStyle.width;
});

var _cvvFormat = function _cvvFormat(value) {
  return String(value).replace(/[^\d]/g, '');
};

var CVVInput = _react["default"].forwardRef(function (_ref, ref) {
  var value = _ref.value,
      theme = _ref.theme,
      Component = _ref.component,
      className = _ref.className,
      style = _ref.style,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["value", "theme", "component", "className", "style"]);
  return _react["default"].createElement(Root, {
    className: className,
    inputStyle: style
  }, _react["default"].createElement(Component, (0, _extends2["default"])({}, rest, {
    style: style,
    value: (0, _react.useMemo)(function () {
      return _cvvFormat(value);
    }, [value]),
    ref: ref
  })));
});

CVVInput.defaultProps = {
  placeholder: '123',
  type: 'tel',
  maxLength: 3,
  autoComplete: 'cc-csc',
  component: _Input["default"]
};
CVVInput.propTypes = {
  placeholder: _propTypes["default"].string,
  type: _propTypes["default"].string,
  autoComplete: _propTypes["default"].string,
  value: _propTypes["default"].any,
  maxLength: _propTypes["default"].number,
  component: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])
};
var _default = CVVInput;
exports["default"] = _default;